import { Dispatch, SetStateAction } from "react";
import { TrackVersionsObj } from "../../pages/MyTracks/types";
import { TrackVersion } from "../../proto/api_pb";
export interface TrackVersionsProps {
  stopAllSongs: () => void;
  handlePlayPause: (id: string) => void;
  isPlaying: boolean;
  version: TrackVersion;
  isSelected: boolean;
  selectedVersionId: string | undefined;
  handleChange: (timeStamp: number) => Promise<void>;
  updateSelectedTrackVersion: () => void;
  handleOpenDeleteModal: (id: string) => void;
  allowDownload?: boolean | undefined;
  shareToken?: string;
}
export interface TrackVersionGroupProps {
  id: string | undefined;
  selectedVersionId: string | undefined;
  handleChange: (timeStamp: number) => Promise<void>;
  isPlaying: boolean;
  handleStop: (id: string) => void;
  evokeCallBack: number;
  allowDownload: boolean | undefined;
  shareToken?: string;
}
export interface SelectVersionModalProps {
  isSelectVersionModalOpen: boolean;
  setIsSelectVersionModalOpen: Dispatch<SetStateAction<boolean>>;
  versions: TrackVersionsObj[] | undefined;
  setChangeVersionLoading: Dispatch<SetStateAction<boolean>>;
  handleChange: (timeStamp: number) => Promise<void>;
  selectedTrackVersionLabel: string | undefined;
}

export const month = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];